export default __webpack_public_path__ + "static/media/PF.a83801c0.PNG";